/** Open a centred popup window (mirrors PopupCenter from util.js). */
export function popupCenter(url: string, windowName: string, w: number, h: number) {
  const sl = window.screenLeft ?? window.screenX ?? 0;
  const st = window.screenTop ?? window.screenY ?? 0;
  const sw = window.innerWidth || document.documentElement.clientWidth || screen.width;
  const sh = window.innerHeight || document.documentElement.clientHeight || screen.height;
  const left = Math.round(sw / 2 - w / 2 + sl);
  const top = Math.round(sh / 2 - h / 2 + st);
  window.open(url, windowName, `width=${w},height=${h},resizable=yes,scrollbars=yes,left=${left},top=${top}`);
}
